import React, { Component } from 'react';

import {
    Spin,
    Card,
    Statistic,
    Typography,
    Divider,
} from 'antd';

import { LoadingOutlined } from '@ant-design/icons';

import UpgradeBanner from '../../components/UpgradeBanner/UpgradeBanner';

import { useState } from '../../state/StateProvider';

const { Title } = Typography;

const Help = () => {

    const { state, apiKey } = useState();

    const showBanner = Object.keys(state.user).length ? state.user && state.user.plan === '' : true;

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ maxWidth: 800, marginRight: 25 }}>
                <Title level={4} style={{ margin: '10px 0 15px 0' }}>Support</Title>
                <p>
                    As this is a free plugin, we do not provide support. Please refer to our  <a href="https://amzwatcher.com/knowledge-base/" target="_blank">knowledge base</a>.
                </p>
                <p>
                    You may ask the WordPress community for help by posting to the WordPress.org support forum. Response time can range from a few days to a few weeks and will likely be from a non-developer.
                </p>
                <p>
                    If you want a timely response via email from a developer who works on this plugin, <a href="https://amzwatcher.com/pricing/" target="_blank">upgrade to a paid plan of AMZ Watcher</a> and send us an email.
                </p>
                <p>
                    If you've found a bug, <a href="mailto:support@amzwatcher.com">please send us an email</a>.
                </p>
                <Divider />
            </div>
            <div style={{ marginTop: 20 }}>
                {showBanner && <UpgradeBanner />}
            </div>
        </div>
    );
}

export default Help;